/* global $ */
import React from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';

class Carousel extends React.Component {
  componentDidMount() {
    const el = ReactDOM.findDOMNode(this);
    $(el).slick(this.props.slickOptions);
  }

  componentWillUnmount() {
    const el = ReactDOM.findDOMNode(this);
    $(el).slick('unslick');
  }

  componentWillUpdate() {
    const el = ReactDOM.findDOMNode(this);
    $(el).slick('unslick');
  }

  componentDidUpdate() {
    const el = ReactDOM.findDOMNode(this);
    $(el).slick(this.props.slickOptions);
  }

  render() {
    const { className } = this.props;

    return <div className={cn("carousel", className)}>
      {this.props.children}
    </div>
  }
}

export default Carousel;


// WEBPACK FOOTER //
// ./src/components/common/Carousel.js